import Controller from './Controller';
import type Report from '../checks/Report';
import { Combined_CreateOrCopyFSM, Combined_CalculateFSM } from '../commands/combined';
import type { IModelVersion } from './Controller';
import type { OrId } from '../commands/types';
import type { IFSM } from '../../stores/model/metamodel/fsm';

/**
 * Result of an FSM-add command: the report plus the id of the new FSM.
 */
interface AddFSMResult {
  report: Report;
  fsm: string;
}

/**
 * Controller to add a new FSM
 */
export default class AddFSMController extends Controller {
  objectTypeId: string;

  constructor(modelVersion: IModelVersion, objectTypeId: string) {
    super(modelVersion);
    this.objectTypeId = objectTypeId;
  }

  /**
   * Add a new or copy an existing FSM
   *
   * @param {String} name The name for the new FSM.
   * @param {String} copyFrom Optional. Copy from this FSM.
   */
  addFSM = async (name: string, copyFrom?: OrId<IFSM> | null): Promise<AddFSMResult> => {
    let newFsmId: string;
    return this.executeAndCheck((model) => {
      const { checks, fsm } = Combined_CreateOrCopyFSM(model, this.objectTypeId, name, copyFrom);
      newFsmId = fsm.id;
      return checks;
    }).then((report) => {
      return {
        report,
        fsm: newFsmId,
      };
    });
  };

  /**
   * Add a new FSM by calculating it from two given FSMs
   *
   * @param {String} name The name for the new FSM.
   * @param {String} fsm1 The id of the first FSM to calculate from.
   * @param {String} fsm2 The id of the second FSM to calculate from.
   */
  calculateFSM = async (name: string, fsm1: OrId<IFSM>, fsm2: OrId<IFSM>): Promise<AddFSMResult> => {
    let newFsmId: string;
    return this.executeAndCheck((model) => {
      const { checks, fsm } = Combined_CalculateFSM(model, this.objectTypeId, fsm1, fsm2, name);
      newFsmId = fsm.id;
      return checks;
    }).then((report) => {
      return {
        report,
        fsm: newFsmId,
      };
    });
  };
}
